import { profile, socialLinks } from "../data/portfolio";
import "../styles/HeroSection.css";
import { SiSolidity, SiRust, SiTypescript, SiGithub, SiX, SiPython } from "react-icons/si";
import { FaLinkedinIn } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";

const HeroSection = () => {
  return (
    <section id="hero" className="hero-section">
      <div className="hero-container">
        <div className="hero-avatar">
          <img
            src="/img/jan.png"
            alt={profile.name}
            onError={(e) => {
              e.currentTarget.style.display = "none";
              e.currentTarget.nextElementSibling?.classList.add("show");
            }}
          />
          <span className="hero-avatar-fallback">JK</span>
        </div>
        <h1 className="hero-name">{profile.name}</h1>
        <p className="hero-bio">{profile.bio}</p>
        <div className="hero-tech">
          <span className="hero-tech-badge" title="Solidity">
            <SiSolidity className="hero-tech-icon" />
            <span className="hero-tech-name">Solidity</span>
          </span>
          <span className="hero-tech-badge" title="Rust">
            <SiRust className="hero-tech-icon" />
            <span className="hero-tech-name">Rust</span>
          </span>
          <span className="hero-tech-badge" title="TypeScript">
            <SiTypescript className="hero-tech-icon" />
            <span className="hero-tech-name">TypeScript</span>
          </span>
          <span className="hero-tech-badge" title="Python">
            <SiPython className="hero-tech-icon" />
            <span className="hero-tech-name">Python</span>
          </span>
        </div>
        <div className="hero-socials">
          {socialLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="hero-social-link"
              title={link.label}
            >
              {link.label === "GitHub" && (
                <SiGithub className="hero-social-icon" />
              )}
              {link.label === "Twitter" && <SiX className="hero-social-icon" />}
              {link.label === "LinkedIn" && (
                <FaLinkedinIn className="hero-social-icon" />
              )}
              {link.label === "Email" && (
                <HiOutlineMail className="hero-social-icon" />
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
